import { TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useIsDesktop } from "../../../hooks";
import { InfoIconModalConfirm } from "../../InfoIconModalConfirm";
import { HeadingS } from "../../Typography";
import { BasicHeadProps } from "../TableTypesExtended";
import * as Styled from "./BasicTableComponents.styled";


export const BasicTableHead: FC<BasicHeadProps> = (props) => {

    const isDesktop = useIsDesktop();

    return (
        <Styled.TableHeadStyled>
            <TableRow>
                {

                    isDesktop ?
                        <DesktopHead {...props} /> :
                        <MobileHead {...props} />
                }
            </TableRow>
        </Styled.TableHeadStyled>


    );
}


const DesktopHead: FC<BasicHeadProps> = ({ columnTitles, alignRightIndex, translateRoute, priorityCol, headModals }) => {

    const { t } = useTranslation();


    return (
        Array.isArray(columnTitles) &&
        columnTitles.map((headItem, key) =>
            <TableCell key={key} align={key >= alignRightIndex ? "right" : "inherit"}>
                <Styled.TableHeadStack direction="row">
                    <Styled.NewHeadingXS strong scaleDown>
                        {translateRoute ? t(`${translateRoute}.${headItem}`) : headItem}
                    </Styled.NewHeadingXS>

                    {headModals?.[key]?.modalTitle && headModals?.[key]?.modalContent &&
                        <InfoIconModalConfirm title={headModals[key].modalTitle} content={headModals[key].modalContent} />
                    }
                </Styled.TableHeadStack>
            </TableCell>
        )

    )

}

const MobileHead: FC<BasicHeadProps> = ({ columnTitles, translateRoute, priorityCol, headModals }) => {

    const { t } = useTranslation();

    return (
        <>
            <TableCell>
                <Styled.TableHeadStack direction="row">
                    {columnTitles.length >= 1 &&
                        <>
                            <HeadingS strong scaleDown>
                                {translateRoute ? t(`${translateRoute}.${columnTitles[0]}`) : columnTitles[0]}
                            </HeadingS>
                            {
                                headModals?.[0] &&
                                <InfoIconModalConfirm title={headModals[0].modalTitle} content={headModals[0].modalContent} />
                            }
                        </>
                    }
                </Styled.TableHeadStack>
            </TableCell>
            <TableCell align="right">
                <Styled.TableHeadStack direction="row" >

                    {columnTitles.length >= 2 &&
                        <>
                            <HeadingS strong scaleDown>
                                {translateRoute ? t(`${translateRoute}.${columnTitles[priorityCol]}`) : columnTitles[priorityCol]}
                            </HeadingS>
                            {columnTitles.length >= 2 && headModals?.[priorityCol]?.modalTitle && headModals?.[priorityCol]?.modalContent &&
                                <InfoIconModalConfirm title={headModals[priorityCol].modalTitle} content={headModals[priorityCol].modalContent} />
                            }
                        </>
                    }
                </Styled.TableHeadStack>
            </TableCell>


        </>
    )
}